

// For running on 8888 only // Some of them are used in Production

export const BLOOD_RELATIONSHIP_CODES = {
    SPOUSE: '01',
    PARENT_OF_CHILD: '03',
    FOSTER_PARENT: '3F',
    GRANDPARENT: '04',
    GRANDCHILD: '05',
    UNCLE_OR_AUNT: '07',
    PARENT_OF_ADOPTED_CHILD: 'G8',
    ADOPTED_CHILD: '09',
    WARD_OF_COURT_APPOINTED_GUARDIAN: '15',
    STEPPARENT: '16',
    STEPCHILD: '17',
    CHILD: '19',
    COURT_APPOINTED_GUARDIAN: '31',
    SIBLING: '14',
    SELF: '18',
    FORMER_SPOUSE: '25',
    DOMESTIC_PARTNER: '53'
};

const ADOPTED_CHILD = 'ADOPTED_CHILD';
const CHILD = 'CHILD';
const COURT_APPOINTED_GUARDIAN = 'COURT_APPOINTED_GUARDIAN';
const DOMESTIC_PARTNER = 'DOMESTIC_PARTNER';
const GRANDPARENT = 'GRANDPARENT';
const GRANDCHILD = 'GRANDCHILD';
const FORMER_SPOUSE = 'FORMER_SPOUSE';
const FOSTER_CHILD = 'FOSTER_CHILD';
const PARENT_OF_ADOPTED_CHILD = 'PARENT_OF_ADOPTED_CHILD';
const PARENT_OF_CHILD = 'PARENT';
const SELF = 'SELF';
const SIBLING = 'SIBLING';
const SPOUSE = 'SPOUSE';
const STEPCHILD = 'STEPCHILD';
const STEPPARENT = 'STEPPARENT';
const WARD = 'WARD';
const WARD_OF_COURT_APPOINTED_GUARDIAN = 'WARD_OF_COURT_APPOINTED_GUARDIAN';

export const BLOOD_RELATIONSHIP_TYPES = {
    ADOPTED_CHILD,
    CHILD,
    COURT_APPOINTED_GUARDIAN,
    DOMESTIC_PARTNER,
    GRANDCHILD,
    GRANDPARENT,
    FORMER_SPOUSE,
    PARENT_OF_ADOPTED_CHILD,
    PARENT_OF_CHILD,
    SELF,
    SIBLING,
    SPOUSE,
    STEPCHILD,
    STEPPARENT,
    WARD_OF_COURT_APPOINTED_GUARDIAN
};

export const CARETAKER_NOT_CONSIDERED_RELATIONSHIP_TYPES = {
    DOMESTIC_PARTNER,
    FORMER_SPOUSE,
    SPOUSE
};

export const ITF_CONSIDERED_RELATIONSHIP_TYPES = {
    CHILD,
    FOSTER_CHILD,
    STEPCHILD,
    WARD
};
